import React, { useState, useEffect } from 'react';
import { DateBox, NumberBox } from 'devextreme-react';
import LVButtonAccion from '../Basicos/LVButtonAccion';
import ComboAbmConCuentasFinancieras from '../Compuestos/Combos/ComboAbmConCuentasFinancieras';

function LVSelectorFechaCuentaFinancieraNumerico({ onClose, onConfirm }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedCuentaFinanciera, setSelectedCuentaFinanciera] = useState(null);
  const [selectedNumerico, setSelectedNumerico] = useState(null);

  const handleConfirm = () => {
    onConfirm(selectedDate, selectedCuentaFinanciera, selectedNumerico);
  };

  const handleCancel = () => {
    onClose();
  };

  return (

    <div style={{ backgroundColor: '#4a5b78', padding: '20px', border: '1px solid #26e9ce', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>

      <table >
        <tbody>
          <tr>
            <td colSpan={3} align='center' >
              <h3>Seleccionar Fecha</h3>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <DateBox displayFormat="dd/MM/yyyy" value={selectedDate} onValueChange={setSelectedDate} />
            </td>
          </tr>

          <tr style={{ height: '30px' }} />

          <tr>
            <td colSpan={3}>
              <ComboAbmConCuentasFinancieras
                value={selectedCuentaFinanciera}
                IdTipoCuentaFinanciera={0}
                onValueChange={setSelectedCuentaFinanciera} />
            </td>
          </tr>

          <tr style={{ height: '30px' }} />

          <tr>
            <td colSpan={3}>
              <NumberBox value={selectedNumerico} onValueChange={setSelectedNumerico} />
            </td>
          </tr>

          <tr style={{ height: '30px' }} />

          <tr>
            <td><LVButtonAccion onClick={handleConfirm} Texto="CONFIRMAR" /></td>
            <td width={10}></td>
            <td><LVButtonAccion onClick={handleCancel} Texto="CANCELAR" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LVSelectorFechaCuentaFinancieraNumerico;